<template>

<com-item name="players.win" :size="size" :loading="loading" title="Winners & Losers" :has-more="data.total > 5" v-on:more="onMoreClick">

	<template v-slot:about>

		<p>Overall win ratios of players against {{ you }}.</p>

	</template>

	<template v-slot:stats>

		<div class="weight">

			<div class="weight-visual">

				<app-visualisation-quadrants :selected="segmentValue" :labels="['Fewer plays', 'More plays', 'High win %', 'Low win %']" :data="data.grid" v-on:click="onSegmentClick" />

			</div>

			<div class="weight-list">

				<div class="weight-loading"><i class="fa fa-spinner fa-spin" v-if="isLoadingPlayers" /></div>

				<div class="weight-empty" v-if="!isLoadingPlayers && !data.list.length">No players.</div>

				<template v-if="!isLoadingPlayers">

					<app-user type="player" :item="item" v-for="(item, index) in data.list" :key="index" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" :count-percent="true" />

				</template>

			</div>

		</div>
		
	</template>

	<template v-slot:buttons>

		<com-toggle :options="thresholdOptions" :value="thresholdValue" v-on:change="onThresholdChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

		thresholdValue: function() {

			return this.$store.getters['filter/insights/players/wins/threshold'] 

		},

		thresholdOptions: function() {

			var options = []

			options.push({value: 1, text: 'No minimum'})
			options.push({value: 2, text: 'Min. 2 plays'})
			options.push({value: 3, text: 'Min. 3 plays'})
			options.push({value: 4, text: 'Min. 4 plays'})
			options.push({value: 5, text: 'Min. 5 plays'})
			options.push({value: 10, text: 'Min. 10 plays'})
			options.push({value: 25, text: 'Min. 25 plays'})

			return options

		},

		segmentValue: function() {

			return this.$store.getters['filter/insights/players/wins/band'] 

		},

		loading: function() {

			return this.fetching === 'all'

		},

		isLoadingPlayers: function() {

			return this.fetching === 'wins.band' || this.fetching === 'wins.threshold'

		},

		data: function() {

			return this.$store.getters['page/insights/players/wins']

		},

		active: function() {

			return this.data.list.length && !this.loading

		}

	},

	methods: {

		onThresholdChange: function(value) {

			this.$store.commit('filter/insights/players/wins/threshold', value)

		},

		onSegmentClick: function(value) {

			this.$store.commit('filter/insights/players/wins/band', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersWins'
			})
		
		}

	}

}

</script>

<style scoped>

.weight {
	display: grid;
	grid-template-columns: 320px 1fr;
	height: 100%;
}

.weight-list {
	border-left: 1px solid #eee;
}

.is-small-mobile .weight {
	grid-template-columns: 1fr;
	grid-template-rows: 300px auto;
}

.is-small-mobile .weight-list {
	border-left: 0px;
	border-top: 1px solid #eee;
}

.weight-loading {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.weight-loading i {
	font-size: 24px;
	transform-origin: 50% 50%;
	color: #ffc563;
}

.weight-empty {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	font-weight: 400;
	color: #ccc;
}

</style>